const benefits = [
  {
    icon: 'ri-user-star-line',
    title: 'Снижение текучести',
    desc: 'Компании с системой онбординга сокращают текучесть в первые 3 месяца на 30-50%. Сотрудники, прошедшие адаптацию, остаются в компании в 2 раза дольше.',
  },
  {
    icon: 'ri-speed-up-line',
    title: 'Быстрый выход на KPI',
    desc: 'Системный ввод в должность сокращает время выхода на плановые показатели с 6-12 месяцев до 2-4. Новичок приносит прибыль быстрее.',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: 'Рост вовлечённости',
    desc: 'Сотрудники, прошедшие качественный онбординг, показывают вовлечённость на 20-40% выше среднего по компании и становятся амбассадорами бренда.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Снижение ошибок',
    desc: 'Понятные чек-листы и наставник сокращают количество ошибок новичков в 2-3 раза. Меньше ошибок — меньше потерь для бизнеса.',
  },
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Экономия бюджета',
    desc: 'Замена одного уволившегося сотрудника обходится компании в 1,5-3 его годовых оклада. Система адаптации окупается за счёт сохранения каждого третьего новичка.',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Рост эффективности',
    desc: 'Единые стандарты работы ускоряют обучение и делают результаты компании предсказуемыми. Каждый новый сотрудник работает по общим правилам с первого дня.',
  },
  {
    icon: 'ri-file-copy-line',
    title: 'Единые стандарты работы',
    desc: 'Программа адаптации фиксирует лучшие практики и передаёт их каждому новому сотруднику. Компания масштабируется, сохраняя качество работы.',
  },
];

export default function WhyBusinessNeedsOnboarding() {
  return (
    <section className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl md:text-5xl font-bold text-gray-900 text-center mb-6">
          Зачем бизнесу система адаптации персонала
        </h2>
        <p className="text-lg text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
          Компании, которые внедрили программу адаптации сотрудников, получают измеримые преимущества. Это не «приятный бонус» для HR — это прямая экономия бюджета и рост эффективности.
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((item, i) => (
            <div key={i} className="bg-white rounded-xl p-6 border border-gray-100 hover:shadow-md transition-all group">
              <div className="w-12 h-12 bg-teal-600 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2">{item.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}